module.exports = __webpack_public_path__ + "img/127495a.jpg";